import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon, ShieldCheckIcon } from 'lucide-react';
import { business, zones } from '../../data/site';
const reveal = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-80px'
  },
  transition: {
    duration: 0.3,
    ease: [0.23, 1, 0.32, 1]
  }
};
export function AboutSection() {
  const years = new Date().getFullYear() - business.since;
  return <section aria-labelledby="about-title" className="w-full bg-mist text-ink" data-id="element-11" data-mp="3m2yig0msw4mq">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:gap-10 lg:py-32" data-id="element-12" data-mp="3h2auxoxs65x9">
        <motion.div {...reveal} className="lg:col-span-5" data-id="element-13" data-mp="3c99cj6yd7o8x">
          <p className="flex items-start font-display text-[clamp(5rem,18vw,9rem)] font-extrabold leading-[0.85] tracking-[-0.05em] text-ink lg:text-[clamp(5rem,10vw,9rem)]" data-id="element-14" data-mp="37cr8k9auztxn">
            99,9<span className="ml-[0.06em] mt-[0.08em] text-[0.5em] leading-none tracking-normal text-lime-deep" data-id="element-15" data-mp="3visnuzoz45k">%</span>
          </p>
          <p className="mt-5 max-w-xs text-base leading-relaxed text-fog-dark" data-id="element-16" data-mp="1lejl0109q2qm">
            des bactéries éliminées dans l'habitacle. Pour une voiture propre, et surtout saine.
          </p>
        </motion.div>

        <motion.div {...reveal} className="lg:col-span-7 lg:pt-4" data-id="element-17" data-mp="1bn5om23m5j1p">
          <h2 id="about-title" className="font-display text-4xl font-bold leading-[1.05] tracking-tight sm:text-5xl" data-id="element-18" data-mp="1gm04owa74ti4">
            Passionné d'automobile depuis tout petit. À votre porte depuis {years} ans.
          </h2>
          <div className="mt-8 grid gap-6 text-base leading-relaxed text-fog-dark sm:grid-cols-2" data-id="element-19" data-mp="16pdlsd1fkciq">
            <p data-id="element-20" data-mp="sq4g47aup0t0">
              Je m'appelle Kévin. Depuis {business.since}, je redonne une seconde jeunesse aux véhicules du sud de la Somme, directement chez vous, avec une prestation sur mesure.
            </p>
            <p data-id="element-21" data-mp="2n3dhfbt8tg06">
              La vapeur est ma spécialité : une méthode éprouvée, sans chimie agressive, complétée par la rénovation extérieure — lustrage et optiques.
            </p>
          </div>
          <ul className="mt-10 flex flex-col gap-4 border-t border-ink/10 pt-8 sm:flex-row sm:gap-10" data-id="element-22" data-mp="2qmcmdwtluwch">
            <li className="flex items-center gap-3 text-sm font-medium" data-id="element-23" data-mp="2lkdhujm4ptdy">
              <LeafIcon className="h-5 w-5 text-lime-deep" aria-hidden="true" data-id="element-24" data-mp="2gnn2jyi5f1tl" />
              Produits faits maison, 100 % naturels
            </li>
            <li className="flex items-center gap-3 text-sm font-medium" data-id="element-25" data-mp="2bpvdrdcsvvtm">
              <ShieldCheckIcon className="h-5 w-5 text-lime-deep" aria-hidden="true" data-id="element-26" data-mp="39ahlgqzbht4y" />
              Non allergisants
            </li>
          </ul>
        </motion.div>
      </div>

      <div className="marquee-group overflow-hidden border-y border-ink/10 bg-white py-6" aria-label="Zones d'intervention" data-id="element-27" data-mp="2zk5417msug31">
        <ul className="flex w-max animate-marquee items-center" data-id="element-28" data-mp="2um3bzx7eb6ff">
          {[...zones, ...zones].map((zone, i) => <li key={`${zone}-${i}`} aria-hidden={i >= zones.length} className="flex items-center whitespace-nowrap font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-29" data-mp="3s3lf4ccjc5zk" data-mpi={i}>
              <span className="px-8" data-id="element-30" data-mp="3vm143m6t580h">{zone}</span>
              <span className="h-2.5 w-2.5 rounded-full bg-lime" aria-hidden="true" data-id="element-31" data-mp="3gx7hs8tj9ks" />
            </li>)}
        </ul>
      </div>
    </section>;
}